import { uniqBy } from 'lodash';
import type {
    IProvidedServicesAndCompensationPayouts,
    IServiceOrganizationSettings,
} from '@frontend/components/interfaces';
import type { EpisodeCategory } from '../../../../../common/enums/episodeCategory';
import { ServiceActivityCompensationPayoutsHistoryEntry } from './ServiceActivityCompensationPayoutsHistoryEntry';

interface ServiceActivityCompensationPayoutsHistoryProps {
    employmentId?: string;
    episodeCategory: EpisodeCategory;
    organizationId: string;
    serviceEmployments: IProvidedServicesAndCompensationPayouts['serviceEmployments'];
    serviceOrganizationSettings: IServiceOrganizationSettings[];
}
export function ServiceActivityCompensationPayoutsHistory(
    props: Readonly<ServiceActivityCompensationPayoutsHistoryProps>
) {
    const { serviceEmployments } = props;
    const serviceActivities = uniqBy(serviceEmployments.map((se) => se.serviceActivities).flat(), 'id');

    return (
        <>
            {serviceActivities.map((serviceActivity) => (
                <ServiceActivityCompensationPayoutsHistoryEntry
                    key={serviceActivity.id}
                    {...props}
                    serviceActivity={serviceActivity}
                />
            ))}
        </>
    );
}
